import React, { useEffect, useState } from 'react';
import { Chart, registerables } from 'chart.js';
import Layout from '../layout/Layout';
import { PrivateAxios } from '../../request/axios';
import { FaFileContract, FaUsers, FaCalendarAlt, FaMoneyBillWave } from 'react-icons/fa';
import DoughnutStats from './DoughnutStats.js'
import BarMonthsStats from './BarMonthsStats.js'
import RevenusGraphique from './RevenusGraphique';
import Loading from '../loading/Loading.js'
import { useNavigate } from 'react-router-dom';

// Enregistrement des composants nécessaires pour les graphiques
Chart.register(...registerables);

const Home = () => {
  const [statistics, setStatistics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const response = await PrivateAxios.get('/contrat/statistique');
        setStatistics(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStatistics();
  }, []);

  if (isLoading) {
    return <Layout><Loading/></Layout>;
  }

  if (!isLoading && !statistics) {
      return navigate('/logout', { state: { message: 'Une erreur a eu lieu au chargement, merci de tenter de nouveau plus tard.' } });
  }

  return (
    <Layout>
      <div className="p-8 bg-gray-100 min-h-screen">
        {/* Section du titre */}
        <h1 className="text-3xl font-bold text-center text-black mb-8">Statistiques Générales</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

          {/* Bar Chart Section (2/3 de l'écran) */}
          <BarMonthsStats statistics={statistics} />

          {/* Doughnut Chart Section (1/3 de l'écran) */}
          <DoughnutStats statistics={statistics} />

        </div>

        {/* Grille principale des statistiques */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-10 mb-8 text-gray-800">

          {/* Première Carte */}
          <div className="bg-white p-4 rounded-lg shadow-lg flex items-center">
            <FaFileContract className="text-axa-blue-400 text-4xl mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Contrats utilisateur</h3>
              <p className="text-2xl font-bold">{statistics.nombre_total_contrats_user}</p>
            </div>
          </div>

          {/* Deuxième Carte */}
          <div className="col-span-1 bg-white p-4 rounded-lg shadow-lg flex items-center">
            <FaFileContract className="text-axa-blue-400 text-4xl mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Contrats 12 mois (Utilisateur)</h3>
              <p className="text-2xl font-bold">{statistics.nombre_contrats_12mois_user}</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-4 grid-rows-4 gap-8 mt-10 mb-8 text-gray-800">

          {/* Graphique Revenus - occupe les cellules de 1,1 à 3,3 */}
          <div className="col-span-3 row-span-4 bg-white p-6 rounded-lg shadow-lg items-center">
            <RevenusGraphique statistics={statistics} />
          </div>

          {/* Carte: Durée Moyenne - Cellule 4,1 */}
          <div className="col-span-1 bg-white p-4 rounded-lg shadow-lg flex items-center">
            <FaCalendarAlt className="text-axa-blue-400 text-4xl mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Durée Moyenne</h3>
              <p className="text-2xl font-bold">{statistics.duree_moyenne_contrats} jours</p>
            </div>
          </div>

          {/* Carte: Montant Total - Cellule 4,2 */}
          <div className="col-span-1 bg-white p-4 rounded-lg shadow-lg flex items-center">
            <FaMoneyBillWave className="text-axa-blue-400 text-4xl mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Montant Total (Utilisateur)</h3>
              <p className="text-2xl font-bold">{statistics.montant_total_contrats?.toLocaleString('fr-FR')} XPF</p>
            </div>
          </div>

          {/* Carte: Contrats 12 mois Utilisateur - Cellule 4,3 */}
          <div className="bg-white p-4 rounded-lg shadow-lg flex items-center">
            <FaUsers className="text-axa-blue-400 text-4xl mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Contrats (Intermédiaire)</h3>
              <p className="text-2xl font-bold">{statistics.nombre_total_contrats_intermediaire}</p>
            </div>
          </div>

          {/* Carte: Contrats 6 mois Intermédiaire - Cellule 4,4 */}
          <div className="col-span-1 bg-white p-4 rounded-lg shadow-lg flex items-center">
            <FaUsers className="text-axa-blue-400 text-4xl mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Contrats 6 mois (Intermédiaire)</h3>
              <p className="text-2xl font-bold">{statistics.nombre_contrats_6mois_intermediaire}</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
